export const PARTNER_ID_INJECTION_TOKEN = 'PARTNER_ID';
